// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file ui_state_service.proto (package pipeex.uistate.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ui_state_service.proto.
 */
export const file_ui_state_service: GenFile = /*@__PURE__*/
  fileDesc("ChZ1aV9zdGF0ZV9zZXJ2aWNlLnByb3RvEhFwaXBlZXgudWlzdGF0ZS52MSIhChFHZXRVaVN0YXRlUmVxdWVzdBIMCgRrZXlzGAEgAygJIpwBChFTZXRVaVN0YXRlUmVxdWVzdBJCCgdlbnRyaWVzGAEgAygLMjEucGlwZWV4LnVpc3RhdGUudjEuU2V0VWlTdGF0ZVJlcXVlc3QuRW50cmllc0VudHJ5EhMKC3JlbW92ZV9rZXlzGAIgAygJGi4KDEVudHJpZXNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBIoMBCg9VaVN0YXRlUmVzcG9uc2USQAoHZW50cmllcxgBIAMoCzIvLnBpcGVleC51aXN0YXRlLnYxLlVpU3RhdGVSZXNwb25zZS5FbnRyaWVzRW50cnkaLgoMRW50cmllc0VudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAEywAEKDlVpU3RhdGVTZXJ2aWNlElYKCkdldFVpU3RhdGUSJC5waXBlZXgudWlzdGF0ZS52MS5HZXRVaVN0YXRlUmVxdWVzdBoiLnBpcGVleC51aXN0YXRlLnYxLlVpU3RhdGVSZXNwb25zZRJWCgpTZXRVaVN0YXRlEiQucGlwZWV4LnVpc3RhdGUudjEuU2V0VWlTdGF0ZVJlcXVlc3QaIi5waXBlZXgudWlzdGF0ZS52MS5VaVN0YXRlUmVzcG9uc2VCEKoCDVBpcGVlWC5Qcm90b3NiBnByb3RvMw");

/**
 * @generated from message pipeex.uistate.v1.GetUiStateRequest
 */
export type GetUiStateRequest = Message<"pipeex.uistate.v1.GetUiStateRequest"> & {
  /**
   * Keys to read; empty means "return everything".
   *
   * @generated from field: repeated string keys = 1;
   */
  keys: string[];
};

/**
 * Describes the message pipeex.uistate.v1.GetUiStateRequest.
 * Use `create(GetUiStateRequestSchema)` to create a new message.
 */
export const GetUiStateRequestSchema: GenMessage<GetUiStateRequest> = /*@__PURE__*/
  messageDesc(file_ui_state_service, 0);

/**
 * @generated from message pipeex.uistate.v1.SetUiStateRequest
 */
export type SetUiStateRequest = Message<"pipeex.uistate.v1.SetUiStateRequest"> & {
  /**
   * Key/value pairs to upsert.
   *
   * @generated from field: map<string, string> entries = 1;
   */
  entries: { [key: string]: string };

  /**
   * Keys to delete.
   *
   * @generated from field: repeated string remove_keys = 2;
   */
  removeKeys: string[];
};

/**
 * Describes the message pipeex.uistate.v1.SetUiStateRequest.
 * Use `create(SetUiStateRequestSchema)` to create a new message.
 */
export const SetUiStateRequestSchema: GenMessage<SetUiStateRequest> = /*@__PURE__*/
  messageDesc(file_ui_state_service, 1);

/**
 * @generated from message pipeex.uistate.v1.UiStateResponse
 */
export type UiStateResponse = Message<"pipeex.uistate.v1.UiStateResponse"> & {
  /**
   * @generated from field: map<string, string> entries = 1;
   */
  entries: { [key: string]: string };
};

/**
 * Describes the message pipeex.uistate.v1.UiStateResponse.
 * Use `create(UiStateResponseSchema)` to create a new message.
 */
export const UiStateResponseSchema: GenMessage<UiStateResponse> = /*@__PURE__*/
  messageDesc(file_ui_state_service, 2);

/**
 * Durable UI state bridge.
 * 
 * The embedded React UI keeps small workflow-resume markers (e.g. "guided
 * setup completed — start at Mapping Configuration") in WebView2 localStorage.
 * That storage lives inside the WebView2 user-data folder, which the plugin's
 * cache-version guard purges on every plugin version change — wiping the
 * markers and forcing users through the guided flow again. This service
 * mirrors those keys into a plugin-owned JSON file outside the WebView2
 * folder, so the UI can re-hydrate localStorage after any purge or WebView2
 * runtime reinstall.
 *
 * @generated from service pipeex.uistate.v1.UiStateService
 */
export const UiStateService: GenService<{
  /**
   * Read mirrored entries. An empty `keys` list returns every stored entry.
   *
   * @generated from rpc pipeex.uistate.v1.UiStateService.GetUiState
   */
  getUiState: {
    methodKind: "unary";
    input: typeof GetUiStateRequestSchema;
    output: typeof UiStateResponseSchema;
  },
  /**
   * Upsert `entries` and delete `remove_keys`, then return the full snapshot.
   *
   * @generated from rpc pipeex.uistate.v1.UiStateService.SetUiState
   */
  setUiState: {
    methodKind: "unary";
    input: typeof SetUiStateRequestSchema;
    output: typeof UiStateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_ui_state_service, 0);

